import { ReactNode } from "react";

type MutationErrorEvent =
  | {
      errorMessageId: string;
      errorMessageValues?: Record<string, ReactNode>;
    }
  | {
      errorMessageId?: never;
      errorMessageValues?: never;
    };

type Listener = (event: MutationErrorEvent) => void;

const listeners = new Set<Listener>();

const publishMutationError = (event: MutationErrorEvent): void => {
  listeners.forEach((listener) => listener(event));
};

const subscribeMutationError = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export {
  publishMutationError,
  subscribeMutationError,
  type MutationErrorEvent,
};
